var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { MessageBox, Trans } from '@lucidlink/uicore';
import { useCountDown } from '#hooks';
export const TickingMessageBox = ({ code, countDownTo, onCountDown, ...rest }) => {
    _react_refresh_temp_2();
    const timeRemaining = useCountDown(countDownTo, onCountDown);
    if (!timeRemaining.toMillis()) {
        return null;
    }
    return (_jsx(MessageBox, { ...rest, children: _jsx(Trans, { i18nKey: code, values: { timeRemaining: timeRemaining.toFormat('m:ss') } }) }));
};
_react_refresh_temp_1 = TickingMessageBox;
$RefreshReg$(_react_refresh_temp_1, "TickingMessageBox");
_react_refresh_temp_2(TickingMessageBox, "7AHfzFIcHXCrTpQPFefGkJWDRsw=", false, () => [useCountDown]);
